// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","spiner":"Loader_spiner__VaQ+8","rotate":"Loader_rotate__NEbL0"};